import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class AnaliseDescontoSolicitacaoCampoPersonalizadoSelecionadoService {

  constructor(private http: HttpClient) { }

  salvar(campos, idAnaliseDesconto) {
    const body = {
      campos: campos,
      idAnaliseDesconto: idAnaliseDesconto
    };

    return this.http.post(globals.apiUrl + '/api/AnaliseDescontoSolicitacaoCampoPersonalizadoSelecionado/Salvar', body);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/AnaliseDescontoSolicitacaoCampoPersonalizadoSelecionado/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  montarParaCadastrar(idAnaliseDesconto, idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/AnaliseDescontoSolicitacaoCampoPersonalizadoSelecionado/MontarParaCadastrar',
      { params: new HttpParams().set('idAnaliseDesconto', idAnaliseDesconto).set('idCupom', idCupom) });
  }
}
